export default "__VITE_ASSET__Bca8lWJX__"